/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    SharedserviceMelcoFusionModelsBlankReferences,
    SharedserviceMelcoFusionModelsBlankReferencesFromJSON,
    SharedserviceMelcoFusionModelsBlankReferencesToJSON,
    SharedserviceMelcoFusionModelsCreateBlank,
    SharedserviceMelcoFusionModelsCreateBlankFromJSON,
    SharedserviceMelcoFusionModelsCreateBlankToJSON,
    SharedserviceMelcoFusionModelsUpdateBlank,
    SharedserviceMelcoFusionModelsUpdateBlankFromJSON,
    SharedserviceMelcoFusionModelsUpdateBlankToJSON,
    SharedserviceMelcoFusionModelsUserBlank,
    SharedserviceMelcoFusionModelsUserBlankFromJSON,
    SharedserviceMelcoFusionModelsUserBlankToJSON,
    SharedserviceMelcoModelsError,
    SharedserviceMelcoModelsErrorFromJSON,
    SharedserviceMelcoModelsErrorToJSON,
    SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem,
    SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemFromJSON,
    SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemToJSON,
} from '../models';

export interface BlanksDraftApiUserBlankCreateDraftRequest {
    sharedserviceMelcoFusionModelsCreateBlank?: SharedserviceMelcoFusionModelsCreateBlank;
}

export interface BlanksDraftApiUserBlankDeleteRequest {
    id: string;
    force?: boolean;
}

export interface BlanksDraftApiUserBlankDuplicateDraftRequest {
    id: string;
}

export interface BlanksDraftApiUserBlankGetDefRequest {
    id: string;
    publishState?: string;
}

export interface BlanksDraftApiUserBlankPublishRequest {
    id: string;
}

export interface BlanksDraftApiUserBlankReferencesRequest {
    id: string;
}

export interface BlanksDraftApiUserBlankRevertRequest {
    id: string;
}

export interface BlanksDraftApiUserBlankSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    publishState?: string;
}

export interface BlanksDraftApiUserBlankUpdateDraftRequest {
    id: string;
    sharedserviceMelcoFusionModelsUpdateBlank?: SharedserviceMelcoFusionModelsUpdateBlank;
}

export interface BlanksDraftApiUserBlanksPreviewRequest {
    id: string;
    height?: number;
    width?: number;
    publishState?: string;
}

/**
 * 
 */
export class BlanksDraftApi extends runtime.BaseAPI {

    /**
     */
    async userBlankCreateDraftRaw(requestParameters: BlanksDraftApiUserBlankCreateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/blanks/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoFusionModelsCreateBlankToJSON(requestParameters.sharedserviceMelcoFusionModelsCreateBlank),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userBlankCreateDraft(requestParameters: BlanksDraftApiUserBlankCreateDraftRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userBlankCreateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankDeleteRaw(requestParameters: BlanksDraftApiUserBlankDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userBlankDelete(requestParameters: BlanksDraftApiUserBlankDeleteRequest): Promise<void> {
        await this.userBlankDeleteRaw(requestParameters);
    }

    /**
     */
    async userBlankDuplicateDraftRaw(requestParameters: BlanksDraftApiUserBlankDuplicateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankDuplicateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}/duplicate/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userBlankDuplicateDraft(requestParameters: BlanksDraftApiUserBlankDuplicateDraftRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userBlankDuplicateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankGetDefRaw(requestParameters: BlanksDraftApiUserBlankGetDefRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userBlankGetDef(requestParameters: BlanksDraftApiUserBlankGetDefRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userBlankGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankPublishRaw(requestParameters: BlanksDraftApiUserBlankPublishRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankPublish.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}/publish`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userBlankPublish(requestParameters: BlanksDraftApiUserBlankPublishRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userBlankPublishRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankReferencesRaw(requestParameters: BlanksDraftApiUserBlankReferencesRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsBlankReferences>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankReferences.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}/references`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsBlankReferencesFromJSON(jsonValue));
    }

    /**
     */
    async userBlankReferences(requestParameters: BlanksDraftApiUserBlankReferencesRequest): Promise<SharedserviceMelcoFusionModelsBlankReferences> {
        const response = await this.userBlankReferencesRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankRevertRaw(requestParameters: BlanksDraftApiUserBlankRevertRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankRevert.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}/revert`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userBlankRevert(requestParameters: BlanksDraftApiUserBlankRevertRequest): Promise<void> {
        await this.userBlankRevertRaw(requestParameters);
    }

    /**
     */
    async userBlankSearchRaw(requestParameters: BlanksDraftApiUserBlankSearchRequest): Promise<runtime.ApiResponse<SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItemFromJSON(jsonValue));
    }

    /**
     */
    async userBlankSearch(requestParameters: BlanksDraftApiUserBlankSearchRequest): Promise<SharedserviceMelcoModelsGenericList1MelcoFusionModelsUserBlankListItem> {
        const response = await this.userBlankSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlankUpdateDraftRaw(requestParameters: BlanksDraftApiUserBlankUpdateDraftRequest): Promise<runtime.ApiResponse<SharedserviceMelcoFusionModelsUserBlank>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlankUpdateDraft.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/blanks/{Id}/draft`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SharedserviceMelcoFusionModelsUpdateBlankToJSON(requestParameters.sharedserviceMelcoFusionModelsUpdateBlank),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SharedserviceMelcoFusionModelsUserBlankFromJSON(jsonValue));
    }

    /**
     */
    async userBlankUpdateDraft(requestParameters: BlanksDraftApiUserBlankUpdateDraftRequest): Promise<SharedserviceMelcoFusionModelsUserBlank> {
        const response = await this.userBlankUpdateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userBlanksPreviewRaw(requestParameters: BlanksDraftApiUserBlanksPreviewRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userBlanksPreview.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.height !== undefined) {
            queryParameters['height'] = requestParameters.height;
        }

        if (requestParameters.width !== undefined) {
            queryParameters['width'] = requestParameters.width;
        }

        if (requestParameters.publishState !== undefined) {
            queryParameters['publish_state'] = requestParameters.publishState;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/blanks/{Id}/canvas/preview`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userBlanksPreview(requestParameters: BlanksDraftApiUserBlanksPreviewRequest): Promise<void> {
        await this.userBlanksPreviewRaw(requestParameters);
    }

}
